// extracted by mini-css-extract-plugin
export default {"submitBtn":"H7vi6CSj1GjIc_TovGNg","errorMessage":"NXjLEgH0fqNky74eD1ey"};